/**------------------------------------------------------
 * Enums
 */
export enum EnumGetApiTokensType {
	Active  = 'active',
	Expired = 'expired'
}


/**------------------------------------------------------
 * Interfaces
 */
export interface IGetApiTokenBalanceResponse {
	tokenBalance: number;
}

export interface IGetApiTokensRequest {
	page  	: number;
	limit 	: number;
}

export interface IGetApiTokensResponse {
	type	: EnumGetApiTokensType;
	results	: IGetApiTokensData[];
}

export interface IGetApiTokensData {
	productName			: string;
	productId 			: string;
	passthroughId		: string;
	orderId 			: string;
	customerMail		: string;
	buyQuantity 		: number; // package count
	tokenCount 			: number; // multiple by the count of the package
	remainingTokenCount : number; // remaining tokens after usage
	expires				: string;
	paymentMethod		: string;
	paymentPrice		: number;
	paymentCurrency		: string;
	invoiceUrl 			: string;
	purchaseDate 		: string;
	status 				: string;
}
